//MODIFY /view/laylout/Layout.vue TO DYNAMICALLY LOAD THIS FILE
const routes = {
  path: "/easyreceipt",
  name: "easyreceipt",
  redirect: "/easyreceipt/adminreports",
  component: () => import("@/view/pages/easyreceipt/index.vue"),
  meta: { authorize: ["easyreceipt:admin"] },
  children: [
    {
      path: "adminreports",
      name: "easyreceipt-adminreports",
      redirect: "/easyreceipt/adminreports/list",
      component: () => import("@/view/pages/easyreceipt/adminreports/index.vue"),
      children: [
        {
          path: "list",
          name: "easyreceipt-adminreports-list",
          props: true,
          component: () => import("@/view/pages/easyreceipt/adminreports/list.vue")
        },
        {
          path: "transactionsummary",
          name: "easyreceipt-adminreports-transactionsummary",
          props: true,
          component: () => import("@/view/pages/easyreceipt/adminreports/transactionsummary.vue")
        }
      ]
    },
    {
      path: "billing",
      name: "easyreceipt-billing",
      redirect: "/easyreceipt/billing/bulkinvoicemembers",
      component: () => import("@/view/pages/easyreceipt/billing/index.vue"),
      children: [
        {
          path: "bulkinvoicemembers",
          name: "easyreceipt-billing-bulkinvoicemembers",
          props: true,
          component: () => import("@/view/pages/easyreceipt/billing/bulkinvoicemembers.vue")
        }
      ]
    },
    {
      path: "adminusers",
      name: "easyreceipt-adminusers",
      redirect: "/easyreceipt/adminusers/list",
      component: () => import("@/view/pages/easyreceipt/adminusers/index.vue"),
      children: [
        {
          path: "list",
          name: "easyreceipt-adminusers-list",
          props: true,
          component: () => import("@/view/pages/easyreceipt/adminusers/list.vue")
        },
        {
          path: "details",
          name: "easyreceipt-adminusers-details",
          props: true,
          component: () => import("@/view/pages/easyreceipt/adminusers/details.vue")
        }
      ]
    },
    {
      path: "audit",
      name: "easyreceipt-audit",
      redirect: "/easyreceipt/audit/list",
      component: () => import("@/view/pages/easyreceipt/audit/index.vue"),
      children: [
        {
          path: "list",
          name: "easyreceipt-audit-list",
          props: true,
          component: () => import("@/view/pages/easyreceipt/audit/list.vue")
        },
      ]
    }
  ]
};

export default routes;
